import { useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE } from '../api';

const BACKEND_URL = API_BASE;

export default function EbayCallback() {
  const [status, setStatus] = useState('processing');
  const [error, setError] = useState('');

  useEffect(() => {
    // Read code RAW from URL — do NOT let URLSearchParams decode it
    const raw = window.location.search;
    const codeMatch = raw.match(/[?&]code=([^&]*)/);
    const stateMatch = raw.match(/[?&]state=([^&]*)/);
    const code = codeMatch ? codeMatch[1] : null;
    const state = stateMatch ? stateMatch[1] : '';

    console.log('[EbayCallback] URL:', window.location.href);
    console.log('[EbayCallback] Code (raw):', code?.substring(0, 40));
    console.log('[EbayCallback] Code length:', code?.length);

    if (!code) {
      setStatus('error');
      setError('Nessun codice ricevuto da eBay');
      notifyOpener('error', 'Nessun codice ricevuto');
      return;
    }

    // sessionStorage guard — survives HMR, React re-mount, everything
    const cacheKey = 'ebay_code_sent';
    if (sessionStorage.getItem(cacheKey) === code) {
      console.log('[EbayCallback] Codice gia inviato (sessionStorage), skip');
      // Still show success since first attempt likely succeeded
      setStatus('success');
      notifyOpener('success', '');
      return;
    }
    sessionStorage.setItem(cacheKey, code);

    // Send code to backend — raw, not decoded
    axios.post(`${BACKEND_URL}/auth/ebay-exchange-public`, { code, state })
      .then((res) => {
        console.log('[EbayCallback] Successo:', res.data);
        setStatus('success');
        notifyOpener('success', '');
      })
      .catch((err) => {
        const msg = err.response?.data?.detail || 'Errore comunicazione server';
        console.error('[EbayCallback] Errore:', msg);
        setStatus('error');
        setError(msg);
        notifyOpener('error', msg);
      });
  }, []);

  function notifyOpener(result, msg) {
    try {
      if (window.opener) {
        window.opener.postMessage({ type: 'ebay_oauth', ebay: result, msg }, '*');
        setTimeout(() => window.close(), 1500);
      }
    } catch (e) {
      setTimeout(() => window.close(), 2000);
    }
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#0A0E1A', padding: 16 }}>
      <div style={{ maxWidth: 360, width: '100%', textAlign: 'center' }}>
        <div style={{ width: 56, height: 56, background: 'linear-gradient(135deg,#7c3aed,#4f46e5)', borderRadius: 16, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px' }}>
          <span style={{ color: 'white', fontWeight: 900, fontSize: 20 }}>IE</span>
        </div>
        {status === 'processing' && (
          <>
            <div style={{ width: 32, height: 32, border: '2px solid #7c3aed', borderTopColor: 'transparent', borderRadius: '50%', animation: 'spin 1s linear infinite', margin: '0 auto 16px' }}></div>
            <p style={{ color: '#fff', fontWeight: 700 }}>Collegamento in corso...</p>
          </>
        )}
        {status === 'success' && (
          <>
            <div style={{ width: 56, height: 56, background: 'rgba(34,197,94,0.2)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
              <span style={{ color: '#4ade80', fontSize: 24 }}>✓</span>
            </div>
            <p style={{ color: '#fff', fontWeight: 700 }}>eBay collegato!</p>
            <p style={{ color: '#6b7280', fontSize: 14, marginTop: 4 }}>Chiusura automatica...</p>
          </>
        )}
        {status === 'error' && (
          <>
            <div style={{ width: 56, height: 56, background: 'rgba(239,68,68,0.2)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
              <span style={{ color: '#f87171', fontSize: 24 }}>✗</span>
            </div>
            <p style={{ color: '#fff', fontWeight: 700, marginBottom: 4 }}>Errore</p>
            <p style={{ color: '#f87171', fontSize: 14, marginBottom: 16 }}>{error}</p>
            <a href="/profilo" style={{ color: '#a78bfa', fontSize: 14 }}>Torna al Profilo</a>
          </>
        )}
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    </div>
  );
}
